import { RiWhatsappFill } from "react-icons/ri";
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";

export const SolutionData = [
  {
    key: 1,
    title: "Automotive Diversity",
    description: "One platform, tens of Brands Cars, hundreds of models!",
  },
  {
    key: 2,
    title: "Regional Dealerships",
    description:
      "Hundreds of showrooms and dealers in different of Iraqi cities",
  },
  {
    key: 3,
    title: "Personalized Solutions",
    description: "Customed and categorical services",
  },
];

export const ValueData = [
  {
    key: 1,
    image: "assets/valueIcon1.png",
    title: "Reliability",
    description: "Rely on us to provide a wide variety of options",
  },
  {
    key: 2,
    image: "assets/valueIcon2.png",
    title: "Renewing",
    description: "We constantly support new additions that meet user needs",
  },
  {
    key: 3,
    image: "assets/valueIcon3.png",
    title: "Modernity",
    description:
      "We adopt simple and modern designs that make the user experience wonderful",
  },
  {
    key: 4,
    image: "assets/valueIcon4.png",
    title: "Quality",
    description:
      "We always strive to ensure that your use of the platform is free from errors and problems ",
  },
  {
    key: 5,
    image: "assets/valueIcon5.png",
    title: "Added Value",
    description:
      "Providing ways and means to achieve mutual benefit among our users",
  },
];

export const AimData = [
  {
    image: "assets/aimIcon1.png",
    title: "Our Mission:",
    description:
      "To create a complete  environment that meets the needs and make the search process easy and fast with a great user experience.",
  },
  {
    image: "assets/aimIcon2.png",
    title: "Our Vision:",
    description:
      "We always strive to provide an enjoyable user experience and support new additions that meet what the user is looking for",
  },
  {
    image: "assets/aimIcon3.png",
    title: "Our Purpose:",
    description: "We make the search process easier and faster!",
  },
];

export const ContactData = [
  {
    title: "WhatsApp",
    text: "Lets chat on WhatsApp!",
    contact: "00964781030984",
    Icon: RiWhatsappFill,
    color: "green",
  },
  {
    title: "Call Us",
    text: "Lets have your Call!",
    contact: "00964781030984",
    Icon: IoCall,
    color: "orange",
  },
  {
    title: "E-mail Us",
    text: "Reach us on our email!",
    contact: "email@outlook.com",
    Icon: MdEmail,
    color: "orange",
  },
];

export const VisitorData = [
  "A comprehensive list of showrooms and dealers throughout Iraq",
  "Dozens of brands and hundreds of different models of cars",
  " Various search methods through simple and advanced filters.",
  "Communicating with showrooms and dealers.",
  "Communicating with showrooms and dealers.",
  "High and stable performance",
  " Continuous additions that meet the purpose and needs of the visitor",
];

export const SellerData = [
  "An integrated platform with multiple tools that meet the seller's purposes.",
  "An integrated notification system.",
  "Statistics that give different insights.",
  " Easiness of communication with the public.",
  "An integrated profile to manage the uploaded materials.",
  "Adopting the concept of SEO and ASO to create future beneficial opportunities and smart access for all interested parties.",
  " A special algorithm that facilitates the arrival of uploaded materials according to what the visitor is looking for.",
  "24 hours Customer Support service",
  "Continuous additions that match user expectations.",
];
